import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Fade from "@mui/material/Fade";
import { Outlet } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Button from "@mui/material/Button";
import LinkIcon from "@mui/icons-material/Link";
import ShareIcon from "@mui/icons-material/Share";
import BusinessIcon from "@mui/icons-material/Business";
import DrawIcon from "@mui/icons-material/Draw";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import LocalHotelIcon from "@mui/icons-material/LocalHotel";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { Grid2, Stack, Typography } from "@mui/material";

function ScrollTop(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({
        block: "center",
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: "fixed", bottom: 16, right: 16 }}
      >
        {children}
      </Box>
    </Fade>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};
const drawerWidth = 240;
const navItems = [
  { id: 0, label: "Inicio", href: "/", target: "_self" },
  {
    id: 5,
    label: "Organizadores",
    href: "/organizadores",
    target: "_self",
  },
  {
    id: 1,
    label: "Patrocinio",
    href: "/patrocinio",
    target: "_self",
  },
  {
    id: 2,
    label: "Hoteles y Transporte",
    href: "/hoteles-y-transporte",
    target: "_self",
  },

  {
    id: 4,
    label: "Tarifas",
    href: "/tarifas",
    target: "_self",
  },
  {
    id: 5,
    label: "Programa",
    href: "/programa",
    target: "_self",
  },
];
export default function Layout(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };
  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <List>
        {navItems.map((item) => (
          <ListItem key={item.id} disablePadding>
            <ListItemButton
              sx={{ textAlign: "center" }}
              href={item.href}
              target={item.target}
            >
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;
  return (
    <React.Fragment>
      <CssBaseline />
      <AppBar
        component="nav"
        style={{ backgroundColor: "#272947" }}
        sx={{ placeItems: { xs: "left", md: "left", lg: "center" } }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            {navItems.map((item) => (
              <Button
                key={item.id}
                sx={{ color: "#fff" }}
                href={item.href}
                target={item.target}
              >
                {item.label}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
      <Box component="main">
        <Toolbar id="back-to-top-anchor" />
        <Box sx={{ display: { xs: 'none', md: 'block', lg: 'block' } }}
        >
          <img src='https://escuela-bancaria.s3.us-east-2.amazonaws.com/2ad49b4b-a8bf-407e-9b57-6360ba3065e2.jpeg' style={{ width: '100%' }} />
        </Box>
        <Outlet />
        <Grid2 container>
          <Grid2 size={{ xs: 12, md: 6, lg: 3 }} p={2}>
            <Stack spacing={5} style={{ textAlign: "center" }}>
              <Typography variant="h5" style={{ color: "#272947" }}>
                <ShareIcon />
                &nbsp;&nbsp;&nbsp;Redes Sociales
              </Typography>
              <List>
                <ListItem disablePadding style={{ textAlign: "center" }}>
                  <ListItemButton
                    style={{ color: "#272947", textAlign: "center" }}
                    href="https://www.linkedin.com/in/escuela-bancaria-de-guatemala-b0286b9b/"
                    target="_blank"
                  >
                    <ListItemIcon
                      style={{ color: "#272947", textAlign: "center" }}
                    >
                      <LinkedInIcon />
                    </ListItemIcon>
                    <ListItemText primary="LinkedIn" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding style={{ textAlign: "center" }}>
                  <ListItemButton
                    target="_blank"
                    href="https://www.facebook.com/abg.ebg"
                    style={{ color: "#272947", textAlign: "center" }}
                  >
                    <ListItemIcon
                      style={{ color: "#272947", textAlign: "center" }}
                    >
                      <FacebookIcon />
                    </ListItemIcon>
                    <ListItemText primary="Facebook" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding style={{ textAlign: "center" }}>
                  <ListItemButton
                    target="_blank"
                    href="https://twitter.com/ABG_EBG"
                    style={{ color: "#272947", textAlign: "center" }}
                  >
                    <ListItemIcon
                      style={{ color: "#272947", textAlign: "center" }}
                    >
                      <XIcon />
                    </ListItemIcon>
                    <ListItemText primary="X" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding style={{ textAlign: "center" }}>
                  <ListItemButton
                    target="_blank"
                    href="https://www.instagram.com/ebg.guatemala/?hl=es-la"
                    style={{ color: "#272947", textAlign: "center" }}
                  >
                    <ListItemIcon
                      style={{ color: "#272947", textAlign: "center" }}
                    >
                      <InstagramIcon />
                    </ListItemIcon>
                    <ListItemText primary="Instagram" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding style={{ textAlign: "center" }}>
                  <ListItemButton
                    target="_blank"
                    href="https://www.youtube.com/@escuelabancariadeguatemala4771"
                    style={{ color: "#272947", textAlign: "center" }}
                  >
                    <ListItemIcon
                      style={{ color: "#272947", textAlign: "center" }}
                    >
                      <YouTubeIcon />
                    </ListItemIcon>
                    <ListItemText primary="YouTube" />
                  </ListItemButton>
                </ListItem>
              </List>
            </Stack>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, lg: 3 }} p={2}>
            <Stack spacing={5} style={{ textAlign: "center" }}>
              <Typography variant="h5" style={{ color: "#272947" }}>
                <LinkIcon />
                &nbsp;&nbsp;&nbsp;Otros enlaces
              </Typography>
              <List>
                <ListItem disablePadding style={{ textAlign: "center" }}>
                  <ListItemButton
                    style={{ color: "#272947", textAlign: "center" }}
                    href="https://visitguatemala.com/"
                    target="_blank"
                  >
                    <ListItemText primary="Visit Guatemala" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding style={{ textAlign: "center" }}>
                  <ListItemButton
                    target="_blank"
                    href="https://www.felaban.net/"
                    style={{ color: "#272947", textAlign: "center" }}
                  >
                    <ListItemText primary="Felaban Online" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding style={{ textAlign: "center" }}>
                  <ListItemButton
                    target="_blank"
                    href="https://www.ebg.edu.gt/"
                    style={{ color: "#272947", textAlign: "center" }}
                  >
                    <ListItemText primary="Asociación Bancaria de Guatemala" />
                  </ListItemButton>
                </ListItem>
              </List>
            </Stack>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, lg: 3 }} p={2}>
            <Stack spacing={5} style={{ textAlign: "center" }}>
              <Typography variant="h5" style={{ color: "#272947" }}>
                <BusinessIcon />
                &nbsp;&nbsp;&nbsp;Organiza
              </Typography>
              <Grid2 container alignItems='center'>
                <Grid2 size={{ xs: 6, md: 6, lg: 6 }}>
                  {" "}
                  <img
                    alt="img"
                    src="https://escuela-bancaria.s3.us-east-2.amazonaws.com/c0a6bc46-1b30-41d8-b874-ab6fa8a5d256.png"
                    style={{ width: "100%" }}
                  />
                </Grid2>
                <Grid2 size={{ xs: 6, md: 6, lg: 6 }}>
                  {" "}
                  <img
                    alt="img"
                    src="https://escuela-bancaria.s3.us-east-2.amazonaws.com/logo+ABG+azul.png"
                    style={{ width: "100%" }}
                  />
                </Grid2>
              </Grid2>
            </Stack>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, lg: 3 }} p={2}>
            <Stack
              spacing={5}
              style={{ textAlign: "center" }}
              alignItems="center"
            >
              <Typography variant="h5" style={{ color: "#272947" }}>
                <DrawIcon />
                &nbsp;&nbsp;&nbsp;Regístrate
              </Typography>
              <img
                alt="img"
                src="https://escuela-bancaria.s3.us-east-2.amazonaws.com/0ac32352-c9eb-41d0-820c-1a08dbd2aeaa.jpeg"
                style={{ width: "50%" }}
              />
              <List>
                <ListItem disablePadding style={{ textAlign: "center" }}>
                  <ListItemButton
                    style={{ color: "#272947", textAlign: "center" }}
                    href="https://registro.felaban.net/congreso/83"
                    target="_blank"
                  >
                    {" "}
                    <ListItemIcon
                      style={{ color: "#272947", textAlign: "center" }}
                    >
                      <DrawIcon />
                    </ListItemIcon>
                    <ListItemText primary="Registro a COPLAFT" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding style={{ textAlign: "center" }}>
                  <ListItemButton
                    target="_blank"
                    href="https://bit.ly/3WGDIqe"
                    style={{ color: "#272947", textAlign: "center" }}
                  >
                    {" "}
                    <ListItemIcon
                      style={{ color: "#272947", textAlign: "center" }}
                    >
                      <LocalHotelIcon />
                    </ListItemIcon>
                    <ListItemText primary="Hospedaje Hotel Casa Santo Domingo" />
                  </ListItemButton>
                </ListItem>
              </List>
            </Stack>
          </Grid2>
        </Grid2>
      </Box>
      <ScrollTop {...props}>
        <Stack spacing={3}>
          <Button startIcon={<DrawIcon />} style={{ backgroundColor: "#272947", color: 'white' }} href={`https://registro.felaban.net/congreso/83`}
            target="_blank">Inscríbete</Button>
          <Fab size="small" aria-label="scroll back to top">
            <KeyboardArrowUpIcon />
          </Fab>
        </Stack>
      </ScrollTop>
    </React.Fragment>
  );
}
